{
	"loginPage": {
		"title": "Iniciar sesión",
		"title2": "Te damos la bienvenida",
		"subtitle": "Envía, recibe y devuelve. Todo en un mismo lugar.",
		"subtitle2": "Ingresa tu contraseña para iniciar sesión como:",
		"form": {
			"email": "Correo electrónico",
			"placeholder_email": "nombre@ejemplo.com",
			"password": "Contraseña",
			"placeholder_password": "**************",
			"checkbox": "Recordar mis datos",
			"forgetPassword": "Olvidé mi contraseña",
			"btnLogin": "Iniciar sesión",
			"btnGoogle": "Continuar con Google",
			"btnFacebook": "Continuar con Facebook",
			"footer": "¿Eres nuevo en fulfillment?",
			"footerLink": "Te ayudamos"
		},
		"errors": {
			"emailInvalid": "Por favor, ingresa un correo válido",
			"passwordInvalid": "Por favor, ingresa una contraseña válida"
		},
		"alert": {
			"code-1202": {
				"msgTitle": "Error",
				"msgSubtitle": "Usuario o contraseña incorrectos"
			}
		},
		"buttons": {
			"continue": "Continuar",
			"create-account": "¿No tienes cuenta? Crear una"
		},
		"links": {
			"forgot-password": "Olvidé mi contraseña",
			"terms-and-conditions": "Términos y condiciones"
		}
	},
	"inputs": {
		"phone": {
			"title": "Teléfono",
			"placeholder": "XXXXXXXXXX"
		},
		"search": {
			"title": "Buscar..."
		}
	},
	"createNewAccount": {
		"title": "Crear cuenta",
		"subtitle": "¡Bienvenido! Para crear tu cuenta, ingresa la siguiente información. Es importante para validar que tus envíos te pertenecen.",
		"form": {
			"first_name": "Nombres",
			"errorMessageFirstName": "Ingresa tu nombre",
			"placeholder_first_name": "John",
			"last_name": "Apellidos",
			"errorMessageLastName": "Ingresa tus apellidos",
			"placeholder_last_name": "Doe",
			"btnLogin": "Iniciar sesión",
			"alert": "Al continuar, aceptas nuestros",
			"&": "y",
			"termsAndConditions": "Términos y Condiciones",
			"privacyPolicy": "Política de Privacidad"
		},
		"dialog": {
			"code-invitation": {
				"title": "Código de propiedad",
				"subtitle": "Ingresa tu código para continuar. Si no lo tienes, solicítalo a administración",
				"buttons": {
					"cancel": "Cancelar",
					"confirm": "Confirmar"
				},
				"error": {
					"codeIncorrect": "El código que ingresaste es incorrecto. Por favor, solicítalo al administrador.",
					"errorOnlyLetters": "Solo se permiten letras y espacios"
				}
			},
			"email-verification": {
				"title": "Verifica tu correo electrónico",
				"subtitle": "Enviamos un código de seguridad de 6 dígitos a",
				"buttons": {
					"resend": "Reenviar",
					"confirm": "Confirmar"
				},
				"error": {
					"codeExpired": "El código que ingresaste expiró. Inténtalo de nuevo."
				},
				"button": {
					"resend": "Reenviar",
					"confirm": "Confirmar"
				}
			}
		},
		"buttons": {
			"continue": "Continuar"
		}
	},
	"identifyUnit": {
		"title": "Identifica esta unidad",
		"subtitle": "Ingresa el código de la unidad para continuar",
		"inputs": {
			"title": "Unidad",
			"placeholder": "Ingresa tu número de unidad o departamento"
		},
		"errors": {
			"unitNotFound": "Unidad no encontrada, favor de verificarla con tu administrador",
			"unitError": "La unidad debe contener almenos 1 caracter"
		},
		"buttons": {
			"continue": "Continuar"
		}
	},
	"setEmail": {
		"title": "¡Ya casi! Ingresa tu correo electrónico",
		"subtitle": "Te notificaremos cuando tus paquetes lleguen a nuestros lockers",
		"inputs": {
			"title": "Correo electrónico",
			"placeholder": "nombre@ejemplo.com"
		},
		"buttons": {
			"continue": "Continuar"
		}
	},
	"setPasswordToAccount": {
		"title": "Crea una contraseña",
		"subtitle": "Completa los siguientes pasos para crear una contraseña segura",
		"inputs": {
			"newPassword": {
				"title": "Nueva contraseña",
				"placeholder": "Ingresa tu contraseña"
			},
			"confirmPassword": {
				"title": "Confirmar contraseña",
				"placeholder": "Confirma tu contraseña"
			}
		},
		"validations": {
			"titleValidations": "Tu contraseña debe cumplir con lo siguiente:",
			"validation0": "Una minúscula",
			"validation1": "Una mayúscula",
			"validation2": "Un número",
			"validation3": "Un carácter especial",
			"validation4": "Mínimo 8 caracteres"
		},
		"buttons": {
			"continue": "Continuar"
		}
	},
	"createNewPassword": {
		"forgotPasswordForm": {
			"title": "Recuperar contraseña",
			"subtitle": "No te preocupes, ingresa el correo asociado a tu cuenta y te ayudaremos a recuperarla.",
			"email": "Correo electrónico",
			"recoverPassword": "Recuperar contraseña",
			"buttonThrowback": "Volver al inicio"
		},
		"title": "Crear nueva contraseña",
		"subtitle": "Completa los campos para recuperar tu cuenta y seguir enviando tus productos.",
		"form": {
			"labelNewPassword": "Nueva contraseña",
			"boxValidation": {
				"title": "Para proteger tu cuenta, asegúrate de que tu contraseña tenga:",
				"validation1": "Una mayúscula",
				"validation2": "Un número",
				"validation3": "Un carácter especial",
				"validation4": "Mínimo 8 caracteres"
			},
			"confirmPassword": "Confirmar contraseña",
			"btnUpdatePassword": "Actualizar contraseña"
		},
		"passwordChanged": {
			"title": "¡Todo listo!",
			"subtitle": "Sabíamos que volverías. Has recuperado tu cuenta y ahora puedes seguir administrando tu red logística con nosotros."
		},
		"passwordNotChanged": {
			"title": "¡Error!",
			"subtitle": "Lo sentimos, por favor intenta el proceso de recuperación nuevamente"
		},
		"oneStepMore": {
			"title": "Solo un paso más...",
			"subtitle-1": "Si el correo",
			"subtitle-2": "está asociado a una cuenta, recibirás un correo con los siguientes pasos. Revisa tu carpeta de spam o correo no deseado.",
			"paragraph-1": "¿No estás seguro del correo que ingresaste?",
			"paragraph-2": "Intenta con uno diferente"
		},
		"buttons": {
			"throwback-login": "Ir al inicio",
			"updatePassword": "Actualizar contraseña",
			"sendEmail": "Reenviar correo",
			"returnBackLogin": "Volver al inicio"
		},
		"notifications": {
			"emailSending": {
				"title": "Correo reenviado",
				"subtitle": "Revisa tu carpeta de spam. Si no lo recibes, verifica que tu correo esté bien escrito."
			}
		}
	},
	"page403": {
		"title": "Error 403",
		"subtitle": "Acceso denegado",
		"paragraph": "Parece que no tienes permiso para ver esta página. Por favor, intenta acceder de nuevo. Si el error persiste, contáctanos para ayudarte."
	},
	"page404": {
		"title": "Error 404",
		"subtitle": "Página no encontrada",
		"paragraph": "No pudimos encontrar lo que buscas. Intenta actualizar la página o volver al inicio."
	},
	"page500": {
		"title": "Error 500",
		"subtitle": "Error del servidor",
		"paragraph": "Hemos encontrado un problema. Intenta actualizar la página o volver al inicio."
	},
	"page503": {
		"title": "Error 503",
		"subtitle": "Servicio no disponible",
		"paragraph": "El servicio no está disponible en este momento. Intenta actualizar la página o volver al inicio."
	},
	"estatus": {
		"RECOLECTADO": "Recolectado",
		"RETURN": "Devuelto",
		"ENTREGADO": "Entregado",
		"SCHEDULED": "Agendado",
		"PENDIENTE": "Pendiente",
		"EXPIRED": "Expirado",
		"EXTENDED": "Extendido",
		"LOCKER": "En Locker",
		"CANCELED": "Cancelado",
		"CANCELED_LOCKER": "Cancelado en Locker",
		"CANCELED_PICKED": "Cancelado Retirado",
		"PASSWORD_EXPIRADO": "Contraseña Expirada",
		"ACTIVE": "Activo",
		"DESACTIVE": "Inactivo",
		"PackageCollected": "Paquete Recolectado",
		"PackageInLocker": "Paquete en Locker",
		"PackageExpired": "Paquete Expirado",
		"Warehouse": "En Almacén",
		"ScheduledDoor": "Puerta Programada",
		"OpenDoor": "Puerta Abierta",
		"CloseDoor": "Puerta Cerrada",
		"FailDoor": "Fallo en Puerta",
		"BusyDoor": "Puerta Ocupada",
		"loginSuccess": "Inicio de sesión exitoso",
		"loginError": "Error al iniciar sesión",
		"useMasterCode": "Usar Código Maestro",
		"logout": "Cerrar sesión"
	},
	"common": {
		"no_data_available": "No hay datos disponibles"
	},
	"alerts": {
		"userRegistered": {
			"title": "Usuario ya registrado",
			"subtitle": "Verifica con tu administrador"
		},
		"invalidCode": {
			"title": "Código inválido",
			"subtitle": "Reenvía el correo e ingresa el código correcto"
		},
		"emailRegistered": {
			"title": "Correo o Teléfono ya registrado",
			"subtitle": "Revisa tus credenciales o recupera tu contraseña"
		},
		"code-1202": {
			"msgTitle": "Error",
			"msgSubtitle": "Usuario o contraseña incorrectos"
		},
		"code-1500": {
			"msgTitle": "Error",
			"msgSubtitle": "Datos duplicados"
		},
		"code-1501": {
			"msgTitle": "Error",
			"msgSubtitle": "Error inesperado del servidor"
		},
		"code-1518": {
			"msgTitle": "Usuario no encontrado",
			"msgSubtitle": "Verifica tu correo y contraseña"
		},
		"code-1502": {
			"msgTitle": "Error",
			"msgSubtitle": "Error al guardar la empresa y sucursales"
		},
		"code-9999": {
			"msgTitle": "Credenciales inválidas",
			"msgSubtitle": "Usuario o contraseña inválida"
		}
	},
	"input-alerts": {
		"code-1518": {
			"email": "Correo electrónico incorrecto",
			"password": "Contraseña incorrecta"
		}
	},
	"homePage": {
		"title": "¡Hola,",
		"activity": "Actividad",
		"availableService": {
			"title": "Servicios disponibles",
			"options": {
				"consumerPendingPayment": {
					"title": "Pago pendiente",
					"subtitle": "Activa tu servicio para agendar paquetes y recibir envíos en el locker"
				},
				"schedulePackage": {
					"title": "Agendar Paquete",
					"subtitle": "Programa la entrega de tus paquetes"
				},
				"rentCompartment": {
					"title": "Rentar compartimiento",
					"subtitle": "Alquila un compartimiento por el tiempo que necesites"
				},
				"shareCompartment": {
					"title": "Compartir compartimiento",
					"subtitle": "Comparte tu compartimiento con familiares y amigos"
				},
				"scheduledCompartment": {
					"title": "Agendar Compartimiento",
					"subtitle": "Reserva un compartimiento para uso futuro"
				}
			}
		},
		"pendingPaymentService": {
			"title": "Servicios disponibles",
			"options": {
				"consumerPendingPayment": {
					"title": "Pago pendiente",
					"subtitle": "Para poder hacer uso de la aplicacion debes de hacer el pago correspondiente"
				}
			}
		},
		"cards": {
			"card1": {
				"title": "En locker",
				"tooltip": "Paquetes actuales en lockers",
				"footer": "Paquetes en locker"
			},
			"card2": {
				"title": "Entregados",
				"tooltip": "Paquetes entregados desde la primera sesión del usuario",
				"footer": "Paquetes entregados"
			},
			"card3": {
				"title": "Agendados",
				"tooltip": "Paquetes agendados por el usuario",
				"footer": "Paquetes agendados"
			},
			"card4": {
				"title": "Recientes",
				"tooltip": "Paquetes que han ingresado recientemente al locker",
				"footer": "Paquetes recientes"
			}
		},
		"overlay": {
			"noRows": {
				"inLocker": {
					"title": "No hay nada aquí...",
					"subtitle": "Esta tabla muestra los pedidos en el locker y su información."
				},
				"completed": {
					"title": "No hay nada aquí...",
					"subtitle": "Esta tabla muestra los pedidos completados y su información."
				},
				"schedule": {
					"title": "No hay nada aquí...",
					"subtitle": "Esta tabla muestra los pedidos agendados y su información."
				},
				"recent": {
					"title": "No hay nada aquí...",
					"subtitle": "Esta tabla muestra los pedidos más recientes y su información."
				}
			}
		},
		"contentSwitcher": {
			"inLocker": "En locker",
			"completed": "Completados",
			"scheduled": "Agendados",
			"recent": "Recientes"
		},
		"table": {
			"common": {
				"order_number": "Número de\npedido",
				"tracking_number": "Tracking",
				"locker_name": "Locker",
				"days_to_expire": "Días para\nexpirar",
				"registration_date": "Fecha de registro",
				"expiration_date": "Fecha de expiración"
			},
			"inlocker": {
				"tracking_number": "Tracking",
				"otp": "OTP",
				"is_a_favor": "¿Es un favor?",
				"locker_name": "Locker",
				"status": "Estado",
				"registration_date": "Fecha de registro",
				"expiration_date": "Fecha de expiración"
			},
			"completed": {
				"tracking_number": "Tracking",
				"hash_package": "Hash del Paquete",
				"is_a_favor": "¿Es un favor?",
				"locker_name": "Locker",
				"status": "Estado",
				"registration_date": "Fecha de\nregistro",
				"package_pickup_date": "Fecha de\nrecolección"
			},
			"schedule": {
				"code_service": "Código de servicio",
				"is_a_favor": "¿Es un favor?",
				"locker_name": "Locker",
				"otp": "OTP",
				"status": "Estado"
			},
			"recent": {
				"tracking_number": "Tracking",
				"order_number": "Número de\npedido",
				"locker_name": "Locker",
				"otp": "OTP",
				"hash_package": "Hash del Paquete",
				"status": "Estado",
				"days_to_expire": "Días para\nexpirar",
				"registration_date": "Fecha de\nregistro",
				"expiration_date": "Fecha de\nexpiración"
			}
		},
		"isAFavor": {
			"no": "No",
			"yes": "Sí"
		},
		"status": {
			"IN_LOCKER": "En locker",
			"EXPIRED_IN_LOCKER": "Expirado",
			"COMPLETED": "Completado",
			"SCHEDULED": "Agendado",
			"EXPIRED_COLLECTED": "Devuelto"
		},
		"myPackages": {
			"title": "Mis Paquetes"
		}
	},
	"orderDetailPage": {
		"title": "Detalle de la orden",
		"back": "Detalles de mi cuenta",
		"cancelPackage": "Cancelar servicio",
		"qrDetail": {
			"scheduled": {
				"text": "Aquí encontrarás tu código de recolección cuando tu paquete sea entregado en el locker."
			},
			"expiredInLocker": {
				"title": "Tu paquete expiró",
				"text": "¿Qué hacer en estos casos?",
				"loading": "Generando código..."
			},
			"inLocker": {
				"title": "Código de recolección",
				"loading": "Generando código..."
			},
			"completed": {
				"title": "Paquete recolectado con éxito",
				"text": "Consulta más información importante sobre tu paquete aquí"
			},
			"expiredCompleted": {
				"title": "Paquete expirado recolectado con éxito",
				"text": "Consulta más información importante sobre tu paquete aquí"
			}
		},
		"informatioPackage": {
			"packageDetail": {
				"title": "Detalle del paquete",
				"subtitle": "Datos de envío y ubicación del locker.",
				"fields": {
					"tracking_number": "Número de envío",
					"locker_name": "Locker",
					"otp": "OTP",
					"is_a_favor": "¿Es un favor?",
					"order_number": "Número de pedido",
					"registration_date": "Fecha de registro",
					"package_pickup_date": "Fecha de\nrecolección",
					"expiration_date": "Fecha de expiración",
					"status": "Estado"
				},
				"status": {
					"IN_LOCKER": "En locker",
					"COMPLETED": "Completado",
					"EXPIRED_COLLECTED": "Devuelto",
					"EXPIRED_IN_LOCKER": "Expirado",
					"SCHEDULED": "Agendado"
				}
			},
			"userDetails": {
				"title": "Detalle del usuario",
				"subtitle": "Datos personales y ubicación registrada.",
				"fields": {
					"full_name": "Nombre completo",
					"vivi-id": "VIVI-ID",
					"email": "Correo electrónico",
					"unity": "Unidad",
					"address": "Ubicación"
				}
			}
		},
		"manualToRecolect": {
			"title": "¿No sabes cómo recolectar?",
			"subtitle": "Aprende cómo recolectar tus paquetes",
			"button": "¿Cómo funciona?"
		},
		"manualToPickUp": {
			"title": "¿Cómo recolectar tu paquete?",
			"list": {
				"option1": "Completa el pago para obtener el código de recolección.",
				"option2": "Acude al locker donde se encuentra tu paquete.",
				"option3": "Escanea el código de recolección para abrir la puerta.",
				"option4": "Recoge tu paquete y cierra la puerta al finalizar."
			}
		},
		"transactionDetail": {
			"title": "Detalle de la transacción",
			"details": {
				"expirationFee": "Tarifa por expiración",
				"perday": "por día",
				"administrationFee": "Tarifa de administración",
				"totalValue": "del valor total",
				"subtotal": "Subtotal",
				"total": "Total"
			},
			"alert": {
				"urlError": {
					"title": "No pudimos generar el enlace de pago",
					"subtitle": "Por favor intenta de nuevo o contacta al administrador."
				},
				"error": {
					"title": "Error al procesar el pago",
					"subtitle": "Ocurrió un problema al comunicarse con el servidor."
				}
			}
		},
		"buttons": {
			"title": "Continuar con el pago"
		}
	},
	"schedulePackagePage": {
		"title": "Registrar un paquete",
		"details": {
			"title": "Ingresa la siguiente información para continuar",
			"whichProperty": "¿En qué propiedad recibirás?",
			"changeLocation": "Cambiar ubicación",
			"fields": {
				"tracking_number": "Tracking",
				"haveOtp": "¿Tu paquete tiene OTP?"
			},
			"buttons": {
				"continue": "Continuar",
				"cancel": "Cancelar"
			}
		}
	},
	"preferences": {
		"appartment": "Departamento",
		"notifications": {
			"title": "¡No te pierdas tus notificaciones!",
			"subtitle": "Agrega tu número de teléfono para recibir notificaciones por WhatsApp"
		},
		"account": {
			"title": "Cuenta",
			"fields": {
				"details": "Detalles de mi cuenta",
				"notifications": "Notificaciones",
				"lockerPreferences": "Preferencias del locker",
				"Appearance": "Apariencia"
			},
			"details": {
				"title": "Detalles de mi cuenta",
				"subtitle": "Revisa y administra tu información personal",
				"fields": {
					"username": "Nombre",
					"lastname": "Apellido",
					"email": "Correo electrónico",
					"main_tlf": "Número de teléfono",
					"subtitle_main_tlf": "Requerido para habilitar notificaciones por WhatsApp"
				},
				"chip": {
					"edit": "Editar"
				},
				"alerts": {
					"200": {
						"title": "Datos actualizados",
						"subtitle": "Tu información se guardó correctamente"
					},
					"400": {
						"title": "Campos incompletos",
						"subtitle": "Por favor revisa los campos marcados antes de continuar"
					},
					"401": {
						"title": "Sesión expirada",
						"subtitle": "Por seguridad debes iniciar sesión nuevamente"
					},
					"500": {
						"title": "Error inesperado",
						"subtitle": "Ocurrió un problema al actualizar tu información"
					}
				},
				"buttons": {
					"edit": "Editar mi información",
					"changePassword": "Cambiar mi contraseña",
					"save": "Guardar cambios",
					"cancel": "Cancelar"
				},
				"verifyTelephone": {
					"title": "Verificar teléfono",
					"subtitle": "Ingresa tu número para recibir un código de verificación por SMS",
					"alert": {
						"title": "Verificación segura",
						"subtitle": "Te enviaremos un código de 6 dígitos por SMS. El número no será guardado hasta que haya sido verificado correctamente."
					},
					"put-telephone": {
						"title": "Debes ingresar un número",
						"subtitle": "Es necesario agregar tu número para recibir notificaciones"
					},
					"input": {
						"title": "Número de teléfono",
						"footer": "Incluye el código de país (ej. +52 para México)"
					},
					"buttons": {
						"sendCode": "Enviar código",
						"cancel": "Cancelar"
					},
					"success": {
						"title": "¡Éxito! El teléfono ha sido asignado",
						"subtitle": "Ahora el usuario puede activar sus notificaciones por WhatsApp"
					},
					"dialog": {
						"title": "Para continuar, verifica tu número de teléfono",
						"subtitle": "Enviamos un código de seguridad de 6 dígitos a ",
						"edit": "Editar mi número",
						"error": {
							"expiredCode": "El código que ingresaste ha expirado. Intenta nuevamente"
						},
						"buttons": {
							"verified": "Verificar",
							"resend": "Reenviar código"
						}
					}
				}
			},
			"notifications": {
				"mainTitle": "Notificaciones",
				"title": "Notificaciones del sistema",
				"subtitle": "Estas notificaciones se enviarán cuando tengamos actualizaciones sobre tus pedidos",
				"channels": "Canales",
				"systemRequirements": "Requerimientos del sistema",
				"options": {
					"push": "Push",
					"email": "Correo electrónico",
					"subtitleEmail": "Confirmaciones de entrega y recordatorios de recolección",
					"whatsapp": "WhatsApp",
					"subtitleWhatsapp": "Alertas en tiempo real y códigos de acceso al locker"
				},
				"alert": {
					"notificationActivatedEmail": {
						"title": "Notificación activada",
						"subtitle": "Te enviaremos correos electrónicos con información importante."
					},
					"notificationDesactivatedEmail": {
						"title": "Notificación desactivada",
						"subtitle": "No te enviaremos correos electrónicos."
					},
					"notificationActivatedWhatsapp": {
						"title": "Notificaciones de WhatsApp activadas",
						"subtitle": "Te enviaremos mensajes por WhatsApp con información importante."
					},
					"activateWhatsapp": {
						"title": "Primero activa tu número de teléfono",
						"subtitle": "Esto es necesario para que puedas recibir mensajes por WhatsApp."
					},
					"notificationDesactivatedWhatsapp": {
						"title": "Notificaciones de WhatsApp desactivadas",
						"subtitle": "No te enviaremos mensajes por WhatsApp."
					}
				}
			},
			"appearence": {
				"mainTitle": "Apariencia",
				"title": "Elige tu tema preferido",
				"subtitle": "Selecciona entre los temas preestablecidos o sigue las preferencias de tu sistema",
				"theme": {
					"light": "Modo claro",
					"dark": "Modo oscuro"
				}
			}
		},

		"support": {
			"title": "Soporte",
			"fields": {
				"helpCenter": "Centro de ayuda",
				"termsConditions": "Términos y condiciones",
				"about": "Acerca de",
				"delete": "Eliminar cuenta"
			},
			"terms": {
				"title": "Términos y condiciones",
				"options": {
					"first": {
						"title": "1. Aceptación de los términos",
						"subtitle": "Al acceder o utilizar la Aplicación de Entrega de Paquetes (en adelante, 'la Aplicación'), aceptas cumplir y quedar sujeto a estos Términos de Servicio (en adelante, 'los Términos'). Si no estás de acuerdo, no debes utilizar la Aplicación."
					},
					"second": {
						"title": "2. Descripción del servicio",
						"subtitle": "La Aplicación ofrece servicios de entrega de paquetes (en adelante, 'el Servicio'). Los usuarios pueden solicitar la recolección y entrega de paquetes a través de la Aplicación dentro de las áreas geográficas habilitadas."
					},
					"third": {
						"title": "3. Elegibilidad",
						"subtitle": "Para utilizar la Aplicación, debes tener al menos 18 años de edad y contar con capacidad legal para contratar. Al utilizarla, declaras que cumples con estos requisitos."
					},
					"four": {
						"title": "4. Registro de cuenta",
						"subtitle": "Para utilizar el Servicio, debes crear una cuenta proporcionando información precisa y completa. Eres responsable de mantener la confidencialidad de tu cuenta y contraseña, así como de notificar cualquier uso no autorizado."
					},
					"five": {
						"title": "5. Uso del servicio",
						"list": {
							"deliveryRequest": {
								"title": "Solicitud de entrega:",
								"subtitle": "Puedes solicitar una entrega proporcionando la información necesaria, incluyendo direcciones y descripción del paquete."
							},
							"restrictions": {
								"title": "Restricciones:",
								"subtitle": "No se permite el envío de materiales ilegales, peligrosos o prohibidos. La Aplicación puede rechazar solicitudes que considere inapropiadas."
							},
							"ratesPayments": {
								"title": "Tarifas y pagos:",
								"subtitle": "Aceptas pagar todas las tarifas asociadas al Servicio. Las tarifas se mostrarán antes de confirmar tu solicitud. Los pagos se procesan mediante los métodos aceptados por la Aplicación."
							}
						}
					}
				}
			},
			"politicsAndPrivacy": {
				"title": "Políticas de privacidad",
				"options": {
					"first": {
						"title": "1. Aceptación de los términos del servicio",
						"subtitle": "Al acceder o utilizar la Aplicación de entrega de paquetes (en adelante, 'la Aplicación', aceptas cumplir y quedar sujeto a estos Términos de Servicio (en adelante, 'los Términos'). Si no estás de acuerdo, no debes utilizar la Aplicación."
					},
					"second": {
						"title": "2. Descripción del servicio",
						"subtitle": "La Aplicación proporciona servicios de entrega de paquetes (en adelante, 'el Servicio'). Los usuarios pueden solicitar la recolección y entrega de paquetes a través de la Aplicación. El Servicio está disponible únicamente en las áreas geográficas indicadas dentro de la Aplicación."
					},
					"third": {
						"title": "3. Requisitos de edad y capacidad legal",
						"subtitle": "Para utilizar la Aplicación, debes tener al menos 18 años de edad y contar con capacidad legal para celebrar contratos. Al utilizarla, declaras y garantizas que cumples con estos requisitos."
					}
				}
			},
			"helpCenter": {
				"title": "Centro de ayuda",
				"pickupPackage": {
					"title": "¿Cómo funciona?",
					"subtitle": "Recoger un paquete"
				},
				"phoneCall": {
					"title": "Solicitar asistencia",
					"subtitle": "Contáctanos"
				},
				"askedQuestion": {
					"title": "Preguntas frecuentes",
					"subtitle": "Encuentra respuestas rápidas a tus dudas"
				},
				"securityIdentification": {
					"title": "Identificación y seguridad",
					"subtitle": "VIVI-ID y aspectos de seguridad que identifican a los usuarios en los lockers",
					"questions": {
						"q1": "¿Qué es el VIVI-ID y para qué sirve?",
						"q2": "¿Cómo puedo cambiar mi VIVI-ID?",
						"q3": "¿Qué sucede si pierdo el acceso?",
						"q4": "¿Es seguro compartir mi VIVI-ID?"
					},
					"answer": {
						"a1": "El VIVI-ID es un identificador único que facilita y agiliza la entrega de tus pedidos. Al usar tu VIVI-ID, las empresas pueden identificarte rápidamente, asegurando que tus pedidos lleguen a la persona correcta. Para aprovechar al máximo esta herramienta, simplemente agrega tu VIVI-ID al inicio de tu nombre al realizar compras, permitiendo que los sistemas confirmen que los pedidos realmente son tuyos. Tu VIVI-ID siempre está disponible en la pantalla principal de la app y en los detalles de tu locker, listo para copiarse con un solo clic. ¡Es fácil para ti y para todos!",
						"a2": "El VIVI-ID se asigna automáticamente por el sistema cuando creas tu cuenta y te identifica como cliente único del locker. No puede renovarse ni modificarse.",
						"a3": "Puedes recuperar tu cuenta utilizando tu correo electrónico. Solicita el restablecimiento de contraseña, realiza el cambio y recuperarás el acceso a la app, donde estarán disponibles tu VIVI-ID y tus lockers registrados.",
						"a4": "Sí, es completamente seguro. El VIVI-ID no comparte tu información personal; solo te identifica como cliente único dentro del sistema de lockers. Tu correo electrónico se utiliza únicamente para notificaciones de estado y detalles de paquetes."
					}
				},
				"tempPassword": {
					"title": "Uso de contraseñas temporales (OTP)",
					"subtitle": "Guía sobre el OTP y su importancia",
					"questions": {
						"q1": "¿Qué es una contraseña temporal?",
						"q2": "¿Cómo utilizo mi OTP?",
						"q3": "¿Cómo registro un OTP?",
						"q4": "¿Qué sucede si no registro un OTP?",
						"q5": "¿Qué hago si mi OTP no funciona?"
					},
					"answer": {
						"a1": "Una contraseña temporal, también conocida como OTP (One-Time Password), es un código de seguridad único proporcionado por algunas tiendas en línea para garantizar la entrega segura de tu pedido. Esta contraseña sirve para: verificar tu identidad como destinatario legítimo, añadir una capa extra de seguridad a tu entrega y permitirte recibir pedidos de tiendas que utilizan esta función de seguridad en nuestros smart lockers.",
						"a2": "Si recibiste un OTP para tu pedido, puedes usarlo fácilmente con nuestro servicio siguiendo estos pasos: 1. Abre la app Vivipost Smart Lockers. 2. Ve al menú OTP. 3. Sigue las instrucciones en pantalla para registrar tu OTP. Registrar tu OTP asegura que tu pedido pueda entregarse de forma segura en nuestros lockers, brindándote flexibilidad incluso para envíos que requieren seguridad adicional.",
						"a3": "Registrar tu contraseña temporal (OTP) es sencillo: 1. Abre la app Vivipost. 2. En el menú inferior, selecciona el ícono OTP. 3. Completa los campos requeridos: Número de seguimiento: el número proporcionado por la tienda en línea. Contraseña temporal (OTP): el código que recibiste por correo electrónico. Este autoriza al repartidor a dejar tu pedido en el locker. Haz clic en 'Guardar pedido'. ¡Listo! Tu OTP permitirá una entrega segura sin complicaciones. Asegúrate de ingresar correctamente tanto el número de seguimiento como el OTP para evitar problemas en la entrega.",
						"a4": "Si no registras un OTP asignado: 1. La app del locker ofrecerá al repartidor opciones para contactarte (tu información de contacto no se muestra; el mensajero te contactará mediante su plataforma si está permitido). 2. Si el repartidor logra comunicarse contigo y obtiene el OTP, podrá completar la entrega. 3. Si no es posible el contacto, la entrega quedará a discreción de la paquetería. Recomendamos registrar siempre los OTP asignados para evitar retrasos o inconvenientes.",
						"a5": "La aplicación ofrecerá opciones para que el repartidor pueda contactarte (sin mostrar tu información personal) y verificar el OTP contigo. Si no se logra establecer contacto, la entrega dependerá de las políticas de la paquetería."
					}
				},
				"receiptCollect": {
					"title": "Recepción y recolección de pedidos",
					"subtitle": "Proceso de recolección, plazos y notificaciones",
					"questions": {
						"q1": "¿Necesito registrar mis pedidos?",
						"q2": "¿Qué sucede si no recojo mi pedido?",
						"q3": "¿Puedo compartir mi código de recolección?",
						"q4": "¿Qué pasa si no lo recojo a tiempo?"
					},
					"answer": {
						"a1": "No, generalmente no necesitas registrar tus pedidos. Solo es necesario cuando la tienda en línea te asigna una contraseña temporal (OTP). Esto suele aplicar a: ciertos tipos de pedidos o productos de alto valor. Si registras el OTP en nuestra app, este aparecerá para el repartidor al procesar tu pedido, permitiendo la entrega sin necesidad de contactarte. Las notificaciones se envían automáticamente desde nuestro sistema. La mayoría de los pedidos no requieren registro previo.",
						"a2": "Es importante tener en cuenta el período de recolección: tienes 3 días desde que el paquete ingresa al locker para recogerlo. Recibirás notificaciones de recordatorio. Si el plazo expira: tu pedido se marcará como 'Vencido', el administrador será notificado para retirarlo y tu código de recolección se desactivará. Recuperación de un pedido vencido: si el paquete aún está dentro, el administrador puede proporcionarte un nuevo código; si ya fue retirado, el administrador puede entregártelo directamente. Esto garantiza la disponibilidad del locker para todos los usuarios.",
						"a3": "Sí, puedes compartir tu código de recolección, pero considera lo siguiente: Generación y envío: el código se genera y envía únicamente a tu cuenta. Responsabilidad: compartir el código es completamente tu responsabilidad. La persona que tenga el código podrá recoger el pedido en tu nombre. Seguridad: Vivipost no comparte este código con nadie más. Recomendación: compártelo solo cuando sea necesario y con personas de confianza.",
						"a4": "Tienes tres (3) días para recoger tu pedido. Después de ese plazo: el pedido se marcará como 'Vencido' y tu código dejará de funcionar. ¿Qué hacer? Acude con tu empresa/administrador para recoger el pedido. Recomendación: recógelo lo antes posible. Te enviaremos recordatorios para que no se te pase la fecha."
					}
				},
				"serviceCompatibility": {
					"title": "Servicios y compatibilidad",
					"subtitle": "Información sobre compatibilidad con paqueterías",
					"questions": {
						"q1": "¿Puedo recibir pedidos de cualquier paquetería?",
						"q2": "¿Cómo funcionan las entregas internas de la empresa?"
					},
					"answer": {
						"a1": "Sí, nuestro sistema de smart lockers está diseñado para ser versátil y conveniente. Compatibilidad: puedes recibir pedidos de cualquier servicio de mensajería. Entregas internas: puedes recibir envíos o documentos de otros departamentos o ubicaciones de la empresa. Beneficios: evita restricciones de horario de oficina, no depende del personal de seguridad y no requiere entrega directa en escritorio. El remitente puede localizar tu locker utilizando tu VIVI-ID o tu nombre. Recibirás notificaciones automáticas cuando se entregue.",
						"a2": "Sistema de Smart Lockers para entregas internas de empresa: nuestro sistema permite transferencias internas convenientes de documentos, sobres sellados o pequeños artículos entre ubicaciones o departamentos. Cualquier empleado puede utilizarlo localizando tu cuenta mediante tu VIVI-ID o nombre. Entre sus ventajas se incluyen: evitar restricciones de horario de oficina, eliminar la dependencia del personal de seguridad y permitir entregas confidenciales. Recibirás notificaciones automáticas y solo tú (o alguien con tu código) podrá acceder al compartimiento. Esto mejora la eficiencia en la comunicación y la logística interna."
					}
				}
			},
			"about": {
				"title": "Acerca de la aplicación",
				"subtitle": "Package Hub te permite gestionar tus entregas y recolecciones de paquetes de forma segura y sencilla. ¡Gracias por formar parte de nuestra comunidad!",
				"table": {
					"title": "Información de la aplicación",
					"items": {
						"nameAplication": "Nombre de la aplicación",
						"version": "Versión",
						"lastUpdate": "Última actualización"
					}
				}
			},
			"delete": {
				"title": "Eliminar cuenta",
				"mainTitle": "¿Estás seguro de que deseas eliminar tu cuenta?",
				"mainSubtitle": "Esta acción es permanente y no se puede deshacer. Todos tus datos serán eliminados definitivamente.",
				"buttons": {
					"deleted": "Eliminar cuenta"
				},
				"alerts": {
					"DELETE_USER": {
						"title": "El usuario ha sido eliminado",
						"subtitle": "El usuario ha sido eliminado correctamente. Gracias por usar la aplicación Package Hub."
					},
					"USER_WITH_PACKAGES": {
						"title": "El usuario no fue eliminado",
						"subtitle": "El usuario tiene paquetes asignados"
					}
				}
			}
		},

		"logout": {
			"title": "Cerrar sesión"
		}
	},
	"termsAndConditions": {},
	"calendar": {
		"dayNames": [
			"Domingo",
			"Lunes",
			"Martes",
			"Miércoles",
			"Jueves",
			"Viernes",
			"Sábado"
		],
		"dayNamesShort": ["Dom", "Lun", "Mar", "Mié", "Jue", "Vie", "Sáb"],
		"dayNamesMin": ["D", "L", "M", "X", "J", "V", "S"],
		"monthNames": [
			"Enero",
			"Febrero",
			"Marzo",
			"Abril",
			"Mayo",
			"Junio",
			"Julio",
			"Agosto",
			"Septiembre",
			"Octubre",
			"Noviembre",
			"Diciembre"
		],
		"monthNamesShort": [
			"Ene",
			"Feb",
			"Mar",
			"Abr",
			"May",
			"Jun",
			"Jul",
			"Ago",
			"Sep",
			"Oct",
			"Nov",
			"Dic"
		],
		"today": "Hoy",
		"clear": "Limpiar"
	},
	"navbar": {
		"welcome": "Bienvenido a tu ",
		"home": "Home",
		"activity": "Actividad",
		"preferences": "Preferencias"
	},
	"tutorial": {
		"title": "Como funciona?",
		"first-step": {
			"title": "Flexible y accesible",
			"subtitle": "Cuando tu orden sea ingresada en uno de nuestros lockers, te enviaremos un código QR y un código numérico para recolectarla."
		},
		"second-step": {
			"title": "No más de un minuto",
			"subtitle": "Eso tardarás en recolectar tus órdenes en nuestros lockers. Solo escanea o ingresa tu código y listo."
		},
		"third-step": {
			"title": "No olvides cerrar la puerta",
			"subtitle": "Nuestros lockers son para todos. Te pedimos que cierres la puerta al finalizar para continuar brindándote el servicio."
		},
		"buttons": {
			"next": "Siguiente",
			"finish": "Finalizar"
		}
	},
	"activity": {
		"title": "Actividad",
		"subtitle": "Consulta el estado de tus envíos y accede a los detalles de cada paquete.",
		"cards": {
			"card1": {
				"title": "En proceso"
			},
			"card2": {
				"title": "Programado"
			},
			"card3": {
				"title": "Completado"
			}
		}
	},
	"scheduledSection": {
		"title": "Agendados",
		"viewAll": "Ver todos",
		"table": {
			"service": "Servicio",
			"locker": "Locker",
			"status": "Estado",
			"otp": "OTP",
			"favor": "Es favor",
			"scheduled": "Agendado",
			"yes": "Sí",
			"no": "No"
		},
		"empty": {
			"title": "No tienes servicios programados",
			"subtitle": "Cuando agendes un servicio, aparecerá aquí para que puedas darle seguimiento fácilmente."
		}
	},
	"inLockerSection": {
		"title": "En locker",
		"viewAll": "Ver todos",
		"table": {
			"tracking": "Tracking",
			"locker": "Locker",
			"expires": "Expira",
			"days": "Días",
			"favor": "Favor",
			"expired": "Expirado",
			"daysSuffix": "días",
			"yes": "Sí",
			"no": "No"
		},
		"empty": {
			"title": "No tienes paquetes en el locker",
			"subtitle": "Cuando recibas un paquete, aparecerá aquí para que puedas recogerlo antes de que caduque"
		}
	},

	"activateServicePage": {
		"title": "Activa el servicio de lockers",
		"subtitle": "Completa tu pago único para desbloquear las funciones de Package Hub, incluyendo recepción de paquetes 24/7, acceso con código QR y programación de entregas.",

		"paymentMethod": {
			"title": "Método de pago",
			"creditCardTitle": "Tarjeta de crédito",
			"creditCardSubtitle": "Visa, Mastercard, Amex"
		},

		"summary": {
			"title": "Resumen del pedido"
		},

		"cta": {
			"pay": "Pagar y activar servicio",
			"processing": "Procesando…"
		}
	},
	"pendingPayment": {
		"title": "Servicio pendiente de activación",
		"subtitle": "Completa el pago para agendar paquetes y recibir envíos en tu locker de Package Hub.",
		"cta": "Pagar suscripción"
	},
	"activationSummary": {
		"title": "Acceso a Package Hub",
		"subtitle": "Desbloquea todo el poder de la entrega inteligente con lockers",

		"benefits": {
			"receive": "Recibe paquetes 24/7",
			"qr": "Acceso al locker con código QR",
			"schedule": "Programa entregas"
		},

		"badges": {
			"oneTime": "Pago único",
			"noSubscription": "Sin suscripción",
			"permanent": "Acceso permanente"
		}
	},
	"priceSummary": {
		"breakdown": {
			"serviceActivation": "Activación del servicio"
		},
		"total": "Total",
		"taxesIncluded": "Impuestos incluidos"
	},
	"securityFooter": {
		"secureStripe": "Pago seguro con tecnología Stripe",
		"cardNotStored": "Los datos de tu tarjeta nunca se almacenan",
		"compactStripe": "Seguridad Stripe",
		"compactSSL": "Cifrado SSL"
	},
	"paymentForm": {
		"cardNumber": "Número de tarjeta",
		"expirationDate": "Fecha de expiración",
		"securityCode": "Código de seguridad"
	},

	"expiredPackage": {
		"breadcrumb": {
			"home": "Inicio",
			"expired": "Paquete expirado"
		},
		"title": "Tu paquete ha expirado",
		"subtitle": "Para continuar usando las funcionalidades del smart locker, realiza el pago pendiente para restaurar tu acceso.",
		"status": {
			"disabled": "Acceso deshabilitado",
			"folio": "Folio:"
		},
		"paymentMethod": "Método de pago",
		"summary": {
			"title": "Resumen del pago",
			"subscriptionExpired": "Suscripción vencida",
			"taxes": "Impuestos",
			"total": "Total a pagar"
		},
		"cta": {
			"processing": "Procesando…",
			"payRestore": "Pagar y restaurar acceso"
		}
	},
	"myPackages": {
		"empty": {
			"title": "Sin paquetes",
			"subtitle": "No hay paquetes en esta categoría."
		},
		"meta": {
			"date": "Fecha",
			"otp": "OTP",
			"pendingPayment": "Pago pendiente"
		}
	}
}
